import React, { ReactNode, useEffect, useState } from 'react';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';

interface DynamicSplitProviderProps {
  children: ReactNode;
  config: any;
}

/**
 * Dynamic Split.io provider that reinitializes when configuration changes
 * This is necessary because SplitFactoryProvider doesn't update when props change
 */
export const DynamicSplitProvider: React.FC<DynamicSplitProviderProps> = ({
  children,
  config,
}) => {
  const [providerKey, setProviderKey] = useState(0);
  const [currentConfig, setCurrentConfig] = useState(config);

  // When config changes (especially the __configKey), reinitialize the provider
  useEffect(() => {
    if (config.__configKey !== currentConfig.__configKey) {
      console.log('[Split.io Dynamic Provider] Configuration key changed from', currentConfig.__configKey, 'to', config.__configKey);
      console.log('[Split.io Dynamic Provider] Reinitializing Split provider with new business ID:', config.attributes?.businessId);
      setCurrentConfig(config);
      setProviderKey(prev => prev + 1);
    }
  }, [config, currentConfig]);

  // Remove the internal __configKey before passing to SplitFactoryProvider
  const cleanConfig = React.useMemo(() => {
    const { __configKey, ...cleanedConfig } = config;
    return cleanedConfig;
  }, [config]);

  return (
    <SplitFactoryProvider key={providerKey} config={cleanConfig}>
      {children}
    </SplitFactoryProvider>
  );
};
